import { render } from "./AlertBar.vue?vue&type=template&id=ed5797b0&bindings={\"errorContent\":\"props\",\"classVal\":\"props\",\"idVal\":\"props\"}"
import script from "./AlertBar.vue?vue&type=script&lang=js"
export * from "./AlertBar.vue?vue&type=script&lang=js"

import "./AlertBar.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script